// Videobereiche pro Abteilung. src auf einen Pfad in /public setzen, um das Video zu aktivieren.
// Echte Werkstatt-Videos können KI-Clips jederzeit ersetzen: Datei tauschen oder src/poster anpassen.
export const WORKSHOP_VIDEOS = {
  autoglas: {
    src: "/videos/ki/autoglas_steinschlag.mp4",
    poster: "/videos/ki/autoglas_steinschlag.jpg",
    title: "Steinschlagreparatur mit UV-Spezialharz — so funktioniert's",
    desc: "Visualisierung der professionellen Steinschlagreparatur: Spezialharz wird in den Schaden injiziert und unter UV-Licht ausgehärtet — die Scheibe ist in ca. 30 Minuten wieder stabil.",
    caption: "Steinschlagreparatur mit UV-Spezialharz",
    uploadDate: "2026-06-20",
    duration: "PT5S",
  },
  toenung: {
    src: "/videos/ki/scheibentoenung.mp4",
    poster: "/videos/ki/scheibentoenung.jpg",
    title: "Scheibentönung: Folie professionell anbringen",
    desc: "Visualisierung der professionellen Scheibentönung: Die Tönungsfolie wird blasenfrei auf die hintere Seitenscheibe aufgebracht und angerakelt.",
    caption: "Tönungsfolie blasenfrei anbringen",
    uploadDate: "2026-06-20",
    duration: "PT5S",
  },
  folierung: {
    src: "/videos/ki/folierung.mp4",
    poster: "/videos/ki/folierung.jpg",
    title: "Folierung: Tönungsfolie exakt zuschneiden",
    desc: "Visualisierung der Folienverarbeitung: Hochwertige Tönungsfolie wird exakt auf die Scheibenform zugeschnitten und vorbereitet.",
    caption: "Folie exakt zuschneiden & vorbereiten",
    uploadDate: "2026-06-20",
    duration: "PT5S",
  },
  sattlerei: {
    src: "/videos/ki/sattlerei_dachhimmel.mp4",
    poster: "/videos/ki/sattlerei_dachhimmel.jpg",
    title: "Dachhimmel neu beziehen — so arbeitet die Sattlerei",
    desc: "Visualisierung der Dachhimmel-Erneuerung: Neuer Himmelstoff wird gleichmäßig auf die vorbereitete Trägerplatte aufgezogen und verklebt.",
    caption: "Neuer Himmelstoff wird verklebt",
    uploadDate: "2026-06-20",
    duration: "PT5S",
  },
};
